import truck from './icons/camion.png';
import truckT from './icons/ic-envio-red.png';
import truckTW from './icons/ic-envio-wh.png';
import store from './icons/store.png';
import covid from './icons/covid.png';
import euro from './icons/euro.png';
import smartphone from './icons/smartphone.png';
import card from './icons/targeta.png';
import phone from './icons/telf.png';
import loyaltyCard from './icons/targeta-fidelitzacio.png';
import time from './icons/ic-time.png';
import precio from './icons/ic-precio.png';
import movil from './icons/ic-movil.png';
import pago from './icons/ic-pago.png';
import puntos from './icons/ic-puntos.png';
export default {
    truck,
    truckT,
    truckTW,
    store,
    covid,
    euro,
    smartphone,
    card,
    phone,
    loyaltyCard,
    time,
    precio,
    movil,
    pago,
    puntos,
};
